module.exports = __webpack_public_path__ + "media/common/fonts/rs-plugin/revicons/revicons-a77de540a38981833f9e31bd4c365cc6.eot";